import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  getDoc,
  increment,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../connection";
import logger from "../../../../utils/logger";
import { getGroups } from "./groups";
import { deleteObject, getStorage, ref } from "firebase/storage";

export async function getImages() {
  let groups = await getGroups();

  let imageUrlsPromises = groups.map((group) => {
    return getDocs(collection(db, "gallery", group.id, "images")).then(
      (snap) => {
        let data = snap.docs.map((doc) => {
          return {
            ...doc.data(),
            id: doc.id,
            groupId: group.id,
            groupName: group.groupName,
          };
        });

        return data;
      }
    );
  });

  let images = await Promise.all(imageUrlsPromises).then((imageArrays) => {
    let res = [];
    imageArrays.forEach((array) => {
      res.push(...array);
    });
    return res;
  });

  // let imagePromises = [];
  // let storageRef = storage.ref();
  // groups.forEach(group => {
  //     let galleryRef = storageRef.child(`${group.groupName}/gallery/`);
  //     imagePromises.push(galleryRef.listAll());
  // });

  // let imageRefs = await Promise.all(imagePromises).then(groups => {
  //     let images = [];
  //     groups.forEach(gallery => {
  //         gallery.items.forEach(imageRef => {
  //             images.push(new Promise((resolve, reject) => {
  //                 let metadata = imageRef.getMetadata();
  //                 let url = imageRef.getDownloadURL();

  //                 Promise.all([metadata, url]).then(data => {
  //                     resolve(data)
  //                 })
  //         });

  //     return images
  // }).catch(err => {
  // });

  // let result = await Promise.all(imageRefs).then(data => {
  //     let result = [];
  //     data.forEach(rec => {
  //         result.push({
  //             metadata: rec[0],
  //             url: rec[1]
  //         })
  //     });
  //     return result;
  // });

  return images;
}

export async function downloadImage(path) {
  let xhr = new XMLHttpRequest();
  xhr.responseType = "blob";
  xhr.onload = () => {
    let blob = xhr.response;
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "image";
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  xhr.open("GET", path);
  xhr.send();
}

export const updateUploaderImageCount = async (
  groupId,
  userId,
  type = "increment",
  count = 1
) => {
  try {
    const userGroupRef = doc(db, "userGroup", groupId, "members", userId);
    const userGroupSnap = await getDoc(userGroupRef);

    if (userGroupSnap.exists()) {
      if (type === "increment") {
        await updateDoc(userGroupRef, {
          galleryImageCount: increment(count),
        });
      } else {
        await updateDoc(userGroupRef, {
          galleryImageCount: increment(-count),
        });
      }
    } else {
      logger.warn(
        `User document not found for userId: ${userId} in group: ${groupId}`
      );
    }
  } catch (error) {
    logger.error("Error updating uploader image count:", error);
    throw error;
  }
};

export const deleteBothImageCopies = async (
  pathLarge,
  pathSmall,
  groupId,
  imageId
) => {
  try {
    let resLarge = { success: false };
    let resSmall = { success: false };
    let deletedAnyImage = false;

    if (pathLarge && pathLarge.length > 0) {
      resLarge = await deleteGalleryImage(pathLarge, groupId, imageId, false);
      if (resLarge.success) deletedAnyImage = true;
    }

    // Check if small image exists and delete it
    if (pathSmall && pathSmall.length > 0) {
      resSmall = await deleteGalleryImage(pathSmall, groupId, imageId, false);
      if (resSmall.success) deletedAnyImage = true;
    }

    if (deletedAnyImage) {
      try {
        const docRef = doc(db, "gallery", groupId, "images", imageId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          await deleteDoc(docRef);
          await updateUploaderImageCount(
            groupId,
            docSnap.data().userDocId,
            "decrement",
            1
          );
        }
      } catch (error) {
        logger.error("Error deleting Firestore document:", error);
      }
    }

    return deletedAnyImage;
  } catch (error) {
    logger.error("Error deleting image copies:", error);
    return false;
  }
};

export async function deleteGalleryImage(
  path,
  groupId,
  imageId,
  deleteFirestoreDoc = true
) {
  if (!path || !groupId || !imageId) {
    throw new Error("Missing required parameters: path, groupId, or imageId");
  }

  const storage = getStorage();
  const imageRef = ref(storage, path);

  try {
    await deleteObject(imageRef);

    if (deleteFirestoreDoc) {
      const docRef = doc(db, "gallery", groupId, "images", imageId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await deleteDoc(docRef);
        await updateUploaderImageCount(
          groupId,
          docSnap.data().userDocId,
          "decrement",
          1
        );
        return { success: true };
      } else {
        console.warn(
          `Firestore document not found: gallery/${groupId}/images/${imageId}`
        );
        return { success: false };
      }
    }

    return { success: true };
  } catch (error) {
    console.error("Error deleting image:", error);
    return { success: false };
  }
}
